<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";
import CompleteView from "./actions/Complete.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
    CompleteView,
  },
  created() {
    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.treasury.totalItems / this.filters.pageSize
      );
    },
    patientsPayments() {
      return this.$store.state.treasury.patientsPayments;
    },

  },

  data() {
    return {
      permissions: this.$patientsManagementPermissions.PatientsPaymentsPermissions,

      view: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,

        date: null,
        receiptNo: null,
        fullName: null,
        phoneNo: null,
      },
      headers: [
        { text: 'نوع الحجز ', value: 'patientPaymentType' },
        { text: 'رقم الحجز', value: 'reservationNo' },
        { text: 'رقم لايصال', value: 'receiptNo' },
        { text: 'اسم المريض ', value: 'patientName' },
        { text: 'اسم الطبيب ', value: 'doctorName' },
        { text: 'تاريخ الموعد', value: 'appointmentDate' },
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: "الحالة ", value: "status", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    
      itemId: 0,
    };
  },
  methods: {
    handleClear() {
   this.filters.date = null;
 },
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("treasury/getAll", this.filters);

    },

    addItem() {

      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    completeItem(item) {
      this.itemId = item.id;
      this.view = 4;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`patients/delete`, this.itemId);
    },


    showDialog(item, type) {
      switch (type) {
        case "cancel":
          this.dialogMessage = "هل انت متأكد من رغبتك الغاء العملية";
          break;
        
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },
 
    confirmDialog() {
      this.$store.dispatch(`treasury/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },

    print(item) {
      this.itemId = item.id;
      const routeData = this.$router.resolve(
        `/receipt/${this.itemId}`
      );
      window.open(routeData.href, "_blank");
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>